import styled, { css } from 'styled-components';
import applyResponsiveVdpStyles from '../../_shared/helpers/applyResponsiveVdpStyles';

const StyledContainerVariants = {
  mini: css`
    max-width: 516px;
    min-width: 496px;
    background: ${({ theme }) => theme.COLORS.BASE};
    box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.2);
    border-radius: 3px;
    padding-bottom: ${({ isCSU }) => (isCSU ? '204px' : '174px')};
  `,
  expanded: css`
    width: 1146px;
    max-width: 1146px;
  `
};

export const StyledContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  scroll-snap-type: both mandatory;
  ${({ theme }) =>
    applyResponsiveVdpStyles(theme, {
      mini: StyledContainerVariants.mini,
      expanded: StyledContainerVariants.expanded
    })}
`;

const StyledOverviewBidboxContainerVariants = {
  mini: css`
    flex-direction: column;
  `,
  expanded: css`
    flex-direction: row;
  `
};

export const StyledOverviewBidboxContainer = styled.div`
  display: flex;
  width: 100%;
  ${({ theme }) =>
    applyResponsiveVdpStyles(theme, {
      mini: StyledOverviewBidboxContainerVariants.mini,
      expanded: StyledOverviewBidboxContainerVariants.expanded
    })}
`;

const TransportSellerContainerVariants = {
  mini: css`
    flex-direction: column;
    margin: 0;
  `,
  expanded: css`
    flex-direction: row;
    margin: 9px 0;
  `
};

export const StyledTransportSellerContainer = styled.div`
  display: flex;
  width: 100%;
  ${({ theme }) =>
    applyResponsiveVdpStyles(theme, {
      mini: TransportSellerContainerVariants.mini,
      expanded: TransportSellerContainerVariants.expanded
    })}
`;

export const StyledTIAHContainer = styled.div`
  display: flex;
  width: 100%;
  ${({ theme }) =>
    applyResponsiveVdpStyles(theme, {
      mini: StyledOverviewBidboxContainerVariants.mini,
      expanded: StyledOverviewBidboxContainerVariants.expanded
    })}
`;
